import { CircleDot } from 'lucide-react'
import { useState } from 'react'

import { type BrokersWorkflowSource } from 'utils/web_api.schemas'

import ComboboxMultiSelectFilter from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

// Type-safe source labels - TypeScript will error if any enum value is missing
export const SOURCE_LABELS: Record<BrokersWorkflowSource, string> = {
  enrollment_event: 'Enrollment Event',
  qualifying_life_event: 'Qualifying Life Event',
}

// Convert to options format
export const SOURCE_OPTIONS = Object.entries(SOURCE_LABELS).map(
  ([value, label]) => ({
    value: value as BrokersWorkflowSource,
    label,
  })
)

const SourceFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = SOURCE_OPTIONS.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          {
            groupLabel: 'Source Types',
            options: filteredOptions,
          },
        ]}
        placeholder='Search source types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={SOURCE_OPTIONS}
          noSelectionText='Source'
          pluralIdentifier='sources'
        >
          <CircleDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SourceFilter
